import { alpha } from '@mui/material'

import { colors } from './colors'

export type State = {
  hover: string
  selected: string
  focus: string
  focusVisible: string
  outlinedBorder: string
  disabled: string
  disabledBackground: string
  gradient0: string
  gradient1: string
}

export type States = {
  black: State
  white: State
  text: State
  primary: State
  secondary: State
  info: State
  success: State
  warning: State
  error: State
}

const buildState = (color: string): State => ({
  hover: alpha(color, 0.04),
  selected: alpha(color, 0.08),
  focus: alpha(color, 0.12),
  focusVisible: alpha(color, 0.3),
  outlinedBorder: alpha(color, 0.5),
  disabled: alpha(color, 0.28),
  disabledBackground: alpha(color, 0.12),
  gradient0: alpha(color, 0.1),
  gradient1: alpha(color, 0.02),
})

export const states: States = {
  black: buildState(colors.common.black),
  white: buildState(colors.common.white),
  text: buildState(colors.brandBlack[500]),
  primary: buildState(colors.brandGreen[500]),
  secondary: buildState(colors.grey[100]),
  info: buildState(colors.lightGreen[100]),
  success: buildState(colors.green[800]),
  warning: buildState(colors.orange[800]),
  error: buildState(colors.red[700]),
}
